/**
 * Assessment Results Service
 * Persists Checklist 753 (and other assessment) results to Firestore assessment_results.
 * PRD: docs/PRD_Checklist753_Evaluari.md §6
 */

import { db } from '../firebase';
import { collection, addDoc, Timestamp, query, where, getDocs } from 'firebase/firestore';

const COLLECTION = 'assessment_results';

/**
 * Submit Checklist 753 result to assessment_results.
 * @param {string} organizationId
 * @param {object} payload - { totalScore, totalApplicable, totalPercentage, themeScores[], responses[] }
 * @param {string} userId
 * @param {string} [userName] - optional display name for history
 * @returns {Promise<string>} document id
 */
async function submitChecklist753Result(organizationId, payload, userId, userName) {
  const docRef = await addDoc(collection(db, COLLECTION), {
    instrumentId: 'CHECKLIST_753_WHO_HAND_HYGIENE',
    organizationId,
    completedBy: userId,
    completedByName: userName || null,
    completedAt: Timestamp.now(),
    totalScore: payload.totalScore,
    totalApplicable: payload.totalApplicable,
    totalPercentage: payload.totalPercentage,
    themeScores: payload.themeScores || [],
    responses: payload.responses || [],
  });
  return docRef.id;
}

/**
 * List assessment run history by organization and instrument (e.g. Checklist 753).
 * Sorted by completedAt descending. No delete; view-only.
 */
async function getHistoryByOrganization(organizationId, instrumentId = 'CHECKLIST_753_WHO_HAND_HYGIENE') {
  const q = query(
    collection(db, COLLECTION),
    where('organizationId', '==', organizationId),
    where('instrumentId', '==', instrumentId)
  );
  const snapshot = await getDocs(q);
  const runs = snapshot.docs.map((d) => {
    const data = d.data();
    return {
      id: d.id,
      ...data,
      completedAt: data.completedAt?.toDate?.() ?? (data.completedAt instanceof Date ? data.completedAt : null),
    };
  });
  runs.sort((a, b) => (b.completedAt ? new Date(b.completedAt).getTime() : 0) - (a.completedAt ? new Date(a.completedAt).getTime() : 0));
  return runs;
}

export default {
  submitChecklist753Result,
  getHistoryByOrganization,
};
